<template src="./template.html" />

<script>
import { Stage, Button } from '@neurotrack/web-shared-components'
import ButtonGroup from '@/components/ButtonGroup.vue'
import SymbolLegend from '../SymbolLegend.vue'

export default {
  // TODO: images should always have alt tags, not sure where we can get content for this one though
  name: 'SymbolDigitTrial',
  components: {
    SymbolLegend, Button, ButtonGroup, Stage
  },
  props: {
    legendData: {
      type: Array,
      default: () => []
    },
    leadingImage: {
      type: String,
      default: ''
    },
    trailingImage: {
      type: String,
      default: ''
    },
    positiveButtonLabel: {
      type: String,
      default: '='
    },
    negativeButtonLabel: {
      type: String,
      default: '≠'
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
